module.exports = __webpack_public_path__ + "img/ic_16_delete.2cde37b9.svg";